import { msUrl } from 'settings';

import { api as apiService, ApiService } from './api'
import { IJabuticabaGroup } from 'pages/CostManagement/DefaultCosts/types';

class JabuticabaGroupService {
  constructor(private readonly api: ApiService, private readonly baseURL: string) {}

  public getGroups = (): Promise<IJabuticabaGroup[]> => {
    return this.api.get(`${this.baseURL}/api/jabuticaba/v1/groups/`)
  }
}

export const jabuticabaGroupService = new JabuticabaGroupService(apiService, msUrl)
